import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)


import ui from './modules/ui'

const store = new Vuex.Store({

  modules: {

    ui
  },

})



onResizeFunction()

window.addEventListener('load', onResizeFunction)
window.addEventListener('reload', onResizeFunction)
window.addEventListener('resize', onResizeFunction)

function onResizeFunction() {
  store.commit('ui/updateWindowWidth', window.innerWidth)
}

export default store